import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  reviews: [],
  processing: false,
  processingGetMore: false,
  pagination: {},
};

const getAllReviewsUserSlice = createSlice({
  name: "getAllReviewsUser",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      state.reviews = [];
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      state.reviews = action.payload.data.data || [];
      state.pagination = action.payload.pagination || {};
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    getMore(state) {
      state.processingGetMore = true;
      /* TODO: reducer for pending*/
    },
    getMoreSuccess(state, action) {
      state.processingGetMore = false;
      state.reviews = [...state.reviews, ...(action.payload.data.data || [])];
      state.pagination = action.payload.pagination || {};
    },
  },
});

const { name, actions, reducer } = getAllReviewsUserSlice;
const getAllReviewsUserAction = createAction(name);
const getMoreReviewsUserAction = actions.getMore;

export {
  getAllReviewsUserAction,
  getMoreReviewsUserAction,
  actions as getAllReviewsUserActions,
  reducer as getAllReviewsUserReducer,
};
